import createReducer from '../utils/createReducer';
import actions from '../actions/payoutDetails';
import {checkPayoutDetailsBtnStatus} from '../utils/validate';


const initialState = {};

const actionHandlers = {
    [actions.HANDLE_PAYOUT_DETAILS_FIELD_VALUE_CHANGE](state, {payload}) {
        const bankingCountryList = state.bankingCountryList;
        switch (payload.fieldName) {

            case 'bankingCountry': {
                const primarySite = state?.primarySiteMap?.[payload.fieldValue] ? state.primarySiteMap[payload.fieldValue] : null;
                const currencyList = primarySite? primarySite.currencies : [];
                const showBankingState = payload.fieldValue === 'US';
                return {
                    ...state,
                    bankingCountryCode: payload.fieldValue,
                    bankingCountryInfo: (bankingCountryList instanceof Array) ? bankingCountryList.find((e) => e.countryCode === payload.fieldValue) : null,
                    showBankingState,
                    bankingState: '',
                    primarySite,
                    currencyList,
                    currency: currencyList.length === 1 ? currencyList[0] : '',
                };
            }

            case 'bankingState': return {
                ...state,
                bankingState: payload.fieldValue
            }

            case 'currencySelection': return {
                ...state,
                currency: payload.fieldValue
            }

            default: return {
                ...state
            };
        }
    },

    [actions.PAYOUT_DETAILS_FIELD_ERROR](state, {payload}) {
        switch (payload.fieldName) {

            case 'bankingCountry': return {
                ...state,
                bankingCountryCodeError: payload.msg
            };

            case 'bankingState': return {
                ...state,
                bankingStateError: payload.msg
            }

            case 'currencySelection': return {
                ...state,
                currencyError: payload.msg
            };

            default: return {
                ...state
            };
        }
    },

    [actions.TOGGLE_PAYOUT_DETAILS_CONTINUE_BUTTON](state, {}) {
        const enableContinueButton = checkPayoutDetailsBtnStatus(state);
        return {
            ...state,
            enableContinueButton
        };
    },

    [actions.PAYOUT_DETAILS_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    },

    [actions.DISMISS_ALERT_BOX](state, {}) {
        return {
            ...state,
            serviceError: ''
        };
    },

    [actions.GET_BANKING_COUNTRIES_SUCCESS](state, {payload}) {
        return {
            ...state,
            bankingCountryList: payload.countryList,
            primarySiteMap: payload.primarySiteMap,
        };
    },
};

export default createReducer(actionHandlers, initialState);
